import { render } from "./InnerCategoryComponent.vue?vue&type=template&id=56a40a51&ts=true"
import script from "./InnerCategoryComponent.vue?vue&type=script&lang=ts"
export * from "./InnerCategoryComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__